import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const getSavedQueries = async () => {
  return base.get({
    url: API_PARAM.SAVED_QUERIES,
  });
};

export const getSavedQueriesByGridName = async (gridName) => {
  return base.get({
    url: `${API_PARAM.SAVED_QUERIES_BY_GRID_NAME}/${gridName}`,
  });
};

export const deleteSavedQueries = async (data) => {
  return base.deleteRequest({
    url: API_PARAM.SAVED_QUERIES,
    data: data,
  });
};

export const saveQuery = async (data) => {
  return base.post({ url: API_PARAM.SAVED_QUERIES, data, nonceHeader: true });
};

export const updateQuery = async (data) => {
  return base.patch({ url: API_PARAM.SAVED_QUERIES, data, nonceHeader: true });
};
